var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Deferred } from "./utils/deferred";
import { throwIfNotAFunction } from "./utils/throwIfNotAFunction";
import { batchEvents } from "./utils/batchEvents";
var EventQueue = /** @class */ (function () {
    function EventQueue() {
        this.queuedEvents = [];
    }
    EventQueue.prototype.queueEvent = function (event, options) {
        if (options === void 0) { options = {}; }
        var deferredEvent = new Deferred(event);
        this.queuedEvents.push(deferredEvent);
        if (options.resolveOnQueued) {
            deferredEvent.resolve("Event added to queue");
        }
        return deferredEvent.promise;
    };
    EventQueue.prototype.sendEvents = function (sendHandler, batchSize) {
        throwIfNotAFunction(sendHandler, "Send handler is not a function");
        var queuedEvents = this.getQueuedEvents();
        if (queuedEvents.length === 0)
            return Promise.resolve(true);
        this._clearQueuedEvents();
        var eventBatches = batchEvents(queuedEvents, batchSize);
        return this._sendBatchedEvents(eventBatches, sendHandler);
    };
    EventQueue.prototype.getQueuedEvents = function () {
        return __spreadArray([], this.queuedEvents, true);
    };
    EventQueue.prototype._clearQueuedEvents = function () {
        this.queuedEvents = [];
    };
    EventQueue.prototype._sendBatchedEvents = function (batchedEvents, sendHandler) {
        var _this = this;
        var batches = batchedEvents.map(function (eventBatch) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, this._sendBatch(eventBatch, sendHandler)];
        }); }); });
        return Promise.all(batches).then(function () { return true; });
    };
    EventQueue.prototype._sendBatch = function (eventBatch, sendHandler) {
        return __awaiter(this, void 0, void 0, function () {
            var eventData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        eventData = eventBatch.map(function (_a) {
                            var value = _a.value;
                            return value;
                        });
                        return [4 /*yield*/, sendHandler(eventData)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._onSendEventsSuccess(eventBatch)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, this._onSendEventsFailure(eventBatch, error_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EventQueue.prototype._onSendEventsSuccess = function (deferredEvents) {
        deferredEvents.forEach(function (deferredEvent) { return deferredEvent.resolve(true); });
        return Promise.resolve(true);
    };
    EventQueue.prototype._onSendEventsFailure = function (deferredEvents, error) {
        deferredEvents.forEach(function (deferredEvent) { return deferredEvent.reject(error); });
        var eventData = deferredEvents.map(function (_a) {
            var value = _a.value;
            return value;
        });
        var eventsForReProcessing = this._reProcessEvents(eventData);
        this.queuedEvents = __spreadArray(__spreadArray([], eventsForReProcessing, true), this.queuedEvents, true);
        return Promise.reject(false);
    };
    EventQueue.prototype._reProcessEvents = function (eventData) {
        return eventData.map(function (event) {
            var deferredEvent = new Deferred(event);
            deferredEvent.promise.catch(function () { });
            return deferredEvent;
        });
    };
    return EventQueue;
}());
export default EventQueue;
